// 自定义产品模态框脚本
document.addEventListener('DOMContentLoaded', () => {
    const overlay = document.getElementById('custom-product-modal-overlay');
    const modal = document.getElementById('custom-product-modal');
    const closeButton = modal?.querySelector('.custom-modal-close');
    const contentWrapper = modal?.querySelector('.custom-modal-content-wrapper');
    const loader = modal?.querySelector('.custom-modal-loader'); // 可以保留或移除
    const skeleton = document.getElementById('custom-modal-skeleton'); // 获取骨架屏元素
    const variantIdInput = document.getElementById('custom-modal-variant-id');

    // --- 获取 PC 端元素 ---
    const mainImageDesktop = document.getElementById('custom-modal-main-image-desktop');
    const thumbnailsContainerDesktop = document.getElementById('custom-modal-thumbnails-desktop');
    const titleElDesktop = document.getElementById('custom-modal-title-desktop');
    const priceElDesktop = document.getElementById('custom-modal-price-desktop');
    const comparePriceElDesktop = document.getElementById('custom-modal-compare-price-desktop');
    const priceContainerDesktop = document.getElementById('custom-modal-price-container-desktop');
    const descriptionElDesktop = document.getElementById('custom-modal-description-desktop');
    const showMoreButtonDesktop = document.getElementById('custom-modal-show-more-desktop');
    const buyNowButtonDesktop = document.getElementById('custom-modal-add-to-cart-desktop');
    const bareToolsButtonDesktop = document.getElementById('custom-modal-secondary-button-desktop');

    // --- 获取 移动 端元素 --- (命名保持一致)
    const priceElMobile = document.getElementById('custom-modal-price-mobile');
    const comparePriceElMobile = document.getElementById('custom-modal-compare-price-mobile');
    const priceContainerMobile = document.getElementById('custom-modal-price-container-mobile');
    const descriptionElMobile = document.getElementById('custom-modal-description-mobile');
    const showMoreButtonMobile = document.getElementById('custom-modal-show-more-mobile');
    const buyNowButtonMobile = document.getElementById('custom-modal-add-to-cart-mobile');
    const bareToolsButtonMobile = document.getElementById('custom-modal-secondary-button-mobile');
    const mobileSwiperContainer = document.getElementById('mobile-image-swiper'); // 获取 Swiper 容器

    let isMobileView = window.innerWidth <= 768;
    let mobileSwiperInstance = null;
    let currentProductData = null; // 存储当前加载的产品数据
    let currentProductType = null;

    // 检查核心元素是否存在
    if (!modal || !overlay || !closeButton || !contentWrapper || !skeleton) {
        console.warn('未找到自定义产品模态框核心元素(包括骨架屏)。请确保已包含 Liquid 代码片段和骨架屏HTML。');
        return;
    }

    // 1. "Bare Tools" 按钮处理 (加购并关闭)
    function handleBareToolsAddToCartAndClose(event) {
        event.preventDefault();
        const variantId = variantIdInput.value;
        if (!variantId) {
            alert('请选择一个产品选项。'); // 根据需要改进提示
            return;
        }

        const buttonClicked = event.currentTarget;
        const otherButtonId = buttonClicked.id.includes('desktop') ? 'custom-modal-secondary-button-mobile' : 'custom-modal-secondary-button-desktop';
        const otherButton = document.getElementById(otherButtonId);
        const spanElement = buttonClicked.querySelector('.secondary-span'); // 获取 span

        // 禁用两个按钮并更新文本
        buttonClicked.disabled = true;
        if (spanElement) spanElement.textContent = 'adding...';
        if (otherButton) otherButton.disabled = true;
        const otherSpan = otherButton?.querySelector('.secondary-span');
        if (otherSpan) otherSpan.textContent = 'adding...';


        const formData = {
            'items': [{
                'id': variantId,
                'quantity': 1 // 假设总是加购 1 件
            }]
        };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(errorData => {
                        throw new Error(errorData.description || `HTTP error! status: ${response.status}`);
                    });
                }
                return response.json();
            })
            .then(cart => {
                console.log('商品已添加到购物车 (Bare Tools):', cart);
                document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true, detail: { cart: cart } }));
                // **成功后关闭模态框**
                closeModal();
                // 滚动到指定元素 (可选)
                const targetElement = document.getElementById('activity-product-swiper');
                if (targetElement) {
                    setTimeout(() => {
                        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }, 100);
                } else {
                    console.warn('无法找到 ID 为 "activity-product-swiper" 的元素进行滚动。');
                }
            })
            .catch((error) => {
                console.error('Bare Tools 添加到购物车时出错:', error);
                alert(`添加商品到购物车时遇到问题: ${error.message}`);
                // 恢复按钮状态和文本
                if (spanElement) spanElement.textContent = 'Bloße Werkzeuge';
                buttonClicked.disabled = false;
                if (otherButton) otherButton.disabled = false;
                if (otherSpan) otherSpan.textContent = 'Bloße Werkzeuge';
            });
    }

    // 2. "Buy Now" 按钮处理 (直接跳转结账)
    function handleBuyNow(event) {
        event.preventDefault();
        const variantId = variantIdInput.value;
        if (!variantId) {
            alert('请选择一个产品选项。');
            return;
        }

        const buttonClicked = event.currentTarget;
        const otherButtonId = buttonClicked.id.includes('desktop') ? 'custom-modal-add-to-cart-mobile' : 'custom-modal-add-to-cart-desktop';
        const otherButton = document.getElementById(otherButtonId);
        const spanElement = buttonClicked.querySelector('.primary-span');

        // 禁用两个按钮并更新文本
        buttonClicked.disabled = true;
        if (spanElement) spanElement.textContent = 'Laden...';
        if (otherButton) otherButton.disabled = true;
        const otherSpan = otherButton?.querySelector('.primary-span');
        if (otherSpan) otherSpan.textContent = 'Laden...';

        const quantity = 1; // 假设总是购买 1 件
        const formData = {
            'items': [{
                'id': variantId,
                'quantity': quantity
            }]
        };
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                if (!response.ok) {
                    // 如果添加失败，尝试解析错误信息
                    return response.json().then(errorData => {
                        throw new Error(errorData.description || `添加到购物车失败，状态: ${response.status}`);
                    }).catch(() => {
                        // 如果解析JSON也失败，抛出通用错误
                        throw new Error(`添加到购物车失败，状态: ${response.status}`);
                    });
                }
                // 添加成功，不需要解析返回的 cart 数据，直接准备跳转
                return response.json(); // 或者可以不return，直接在下面跳转
            })
            .then(cart => {
                console.log('商品已添加到购物车 (准备跳转结账):', cart);
                // **成功添加到购物车后，跳转到 checkout 页面**
                window.location.href = '/checkout';
                // 跳转后页面离开，不需要恢复按钮状态
            })
            .catch((error) => {
                console.error('"Buy Now" 添加到购物车时出错:', error);
                alert(`处理购买请求时遇到问题: ${error.message}`);
                // **错误处理：恢复按钮状态和文本**
                buttonClicked.disabled = false;
                if (spanElement) spanElement.textContent = 'Jetzt kaufen';
                if (otherButton) otherButton.disabled = false;
                if (otherSpan) otherSpan.textContent = 'Jetzt kaufen';
            });
    }

    // 3. 格式化货币 (保持不变)
    function formatMoney(cents, format) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        let value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = (format || window.Shopify?.currency?.money_format || '${{amount}}'); // 使用全局或默认格式

        function defaultOption(opt, def) {
            return (typeof opt === 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) { return 0; }

            number = (number / 100.0).toFixed(precision);

            const parts = number.split('.');
            const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            const centsValue = parts[1] ? (decimal + parts[1]) : '';

            return dollars + centsValue;
        }

        try {
            switch (formatString.match(placeholderRegex)[1]) {
                case 'amount':
                    value = formatWithDelimiters(cents, 2);
                    break;
                case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
                case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',');
                    break;
                case 'amount_with_apostrophe_separator':
                    value = formatWithDelimiters(cents, 2, "'", '.');
                    break;
                case 'amount_no_decimals_with_space_separator':
                    value = formatWithDelimiters(cents, 0, ' ', '.');
                    break;
                case 'amount_with_space_separator':
                    value = formatWithDelimiters(cents, 2, ' ', ',');
                    break;
                // 添加更多 Shopify 可能的格式...
                default:
                    value = formatWithDelimiters(cents, 2); // 默认回退
            }
        } catch (e) {
            console.error("Error formatting money, using default.", e);
            value = formatWithDelimiters(cents, 2); // 出错时回退
        }


        return formatString.replace(placeholderRegex, value);
    }

    // --- 新增：更新价格和按钮状态 ---
    function updatePriceAndAvailability(variant) {
        const moneyFormat = window.Shopify?.currency?.money_format || '${{amount}}';
        const currentPriceFormatted = formatMoney(variant.price, moneyFormat);
        const comparePriceFormatted = (variant.compare_at_price && variant.compare_at_price > variant.price)
            ? formatMoney(variant.compare_at_price, moneyFormat)
            : '';
        const showComparePrice = comparePriceFormatted !== '';
        // const isAvailable = variant.available;

        // 更新桌面价格
        if (priceElDesktop) priceElDesktop.textContent = currentPriceFormatted;
        if (comparePriceElDesktop) {
            comparePriceElDesktop.textContent = comparePriceFormatted;
            comparePriceElDesktop.style.display = showComparePrice ? 'inline' : 'none';
        }

        // 更新移动端价格
        if (priceElMobile) priceElMobile.textContent = currentPriceFormatted;
        if (comparePriceElMobile) {
            comparePriceElMobile.textContent = comparePriceFormatted;
            comparePriceElMobile.style.display = showComparePrice ? 'inline' : 'none';
        }

        // 更新按钮状态
        const buyNowButtons = [buyNowButtonDesktop, buyNowButtonMobile];
        const bareToolsButtons = [bareToolsButtonDesktop, bareToolsButtonMobile];

        // buyNowButtons.forEach(btn => { if (btn) btn.disabled = !isAvailable; });
        // bareToolsButtons.forEach(btn => { if (btn) btn.disabled = !isAvailable; });

        // 更新按钮文本（可选：如果缺货可以改变文本）
        // 例如:
        // const buyNowSpans = [buyNowButtonDesktop?.querySelector('.primary-span'), buyNowButtonMobile?.querySelector('.primary-span')];
        // buyNowSpans.forEach(span => { if(span) span.textContent = isAvailable ? 'Buy Now' : 'Sold Out'; });
    }

    // --- 新增：更新图片显示 ---
    function updateVariantImageDisplay(variant, productMedia) {
        if (!variant || !variant.featured_media) return; // 如果变体没有特色图片，则不更新


        const featuredMedia = productMedia.find(media =>
            media.id === variant.featured_media.id
        );
        if (!featuredMedia || !featuredMedia.src) {
            console.warn("无法找到变体的媒体资源", variant.featured_media.id);
            return;
        }
        const featuredMediaId = featuredMedia.id
        const featuredMediaSrc = featuredMedia.src;
        const featuredMediaAlt = featuredMedia.alt || currentProductData?.title || 'Product image'; // 使用 currentProductData

        // 更新桌面主图
        if (mainImageDesktop && featuredMediaSrc) {
            mainImageDesktop.src = featuredMediaSrc;
            mainImageDesktop.alt = featuredMediaAlt;
        }

        // 更新桌面缩略图激活状态
        if (thumbnailsContainerDesktop) {
            thumbnailsContainerDesktop.querySelectorAll('.custom-modal-thumbnail').forEach(thumb => {
                thumb.classList.remove('active');
                // 注意：dataset.mediaId 存的是数字，featuredMediaId 也是数字，直接比较可能ok，转字符串更安全
                if (thumb.dataset.mediaId === String(featuredMediaId)) {
                    thumb.classList.add('active');
                    // 可选：将激活的缩略图滚动到视图中
                    // thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
                }
            });
        }


        // 更新移动端 Swiper
        if (mobileSwiperInstance && !mobileSwiperInstance.destroyed && productMedia) {
            const slideIndex = productMedia.findIndex(media => media.id === featuredMediaId);
            if (slideIndex > -1) {
                // 确保 Swiper 更新后滑动，或者 Swiper 初始化时已使用 initialSlide
                if (mobileSwiperInstance.slides[slideIndex]) { // 检查slide是否存在
                    mobileSwiperInstance.update();
                    setTimeout(() => {
                        mobileSwiperInstance.slideTo(slideIndex);
                    }, 50);
                } else {
                    console.warn("Swiper slideIndex found, but slide does not exist at that index yet:", slideIndex);
                }
            } else {
                console.warn("Could not find slideIndex in Swiper for media ID:", featuredMediaId);
            }
        }
    }

    // --- 新增：更新变体选项的视觉状态 ---
    function updateVariantOptionSelection(selectedValue) {
        // 移除所有选项的 active 类
        document.querySelectorAll('.variant-option').forEach(opt => {
            opt.classList.remove('active');
        });
        // 为匹配 data-value 的选项添加 active 类 (桌面和移动端)
        document.querySelectorAll(`.variant-option[data-value="${selectedValue}"]`).forEach(opt => {
            opt.classList.add('active');
        });
    }

    // --- 新增：处理变体选择的核心函数 ---
    function handleVariantSelection(selectedValue, product) {
        if (!product || !product.variants) return;

        // 1. 查找对应的变体对象
        //    假设选项值（如 "Black"）是唯一的，并且存在于 variant.options 数组中
        const selectedVariant = product.variants.find(variant =>
            variant.options.some(optionValue => optionValue === selectedValue)
        );

        if (selectedVariant) {
            console.log("Selected Variant:", selectedVariant.id, selectedVariant.title, selectedVariant.price);

            // 2. 更新隐藏的 variant ID input
            if (variantIdInput) {
                variantIdInput.value = selectedVariant.id;
            }

            // 3. 更新价格和按钮可用性
            updatePriceAndAvailability(selectedVariant);

            // 4. 更新图片显示
            updateVariantImageDisplay(selectedVariant, product.media);

            // 5. 更新选项视觉状态 (哪个被选中)
            updateVariantOptionSelection(selectedValue);

        } else {
            console.warn("未找到与值匹配的变体:", selectedValue);
            // 可以考虑禁用按钮或显示错误信息
            if (variantIdInput) variantIdInput.value = ''; // 清空 ID
            const allButtons = [buyNowButtonDesktop, buyNowButtonMobile, bareToolsButtonDesktop, bareToolsButtonMobile];
            allButtons.forEach(btn => { if (btn) btn.disabled = true; });
        }
    }

    // 4. 填充模态框数据
    function populateModal(product, productType, selectedVariantId = null) {
        if (!product) return;

        currentProductData = product; // 存储产品数据
        currentProductType = productType;

        // --- 数据准备 ---
        const showBareToolsButton = productType !== 'tools'; // 根据产品类型决定是否显示 "Bare Tools"
        let initialVariant = null;
        if (selectedVariantId) {
            // 尝试查找传入 ID 对应的变体
            initialVariant = product.variants.find(v => v.id == selectedVariantId); // 使用 == 允许字符串和数字比较
            if (initialVariant) {
                console.log("Found requested variant:", initialVariant.id);
            } else {
                console.warn(`传入的 variant ID ${selectedVariantId} 在产品 ${product.handle} 中未找到。将回退选择。`);
            }
        }

        // 如果没有传入 ID 或者传入的 ID 无效，则执行回退逻辑
        if (!initialVariant) {
            initialVariant = product.variants.find(v => v.available) || product.variants[0];
            if (initialVariant) {
                console.log("Falling back to first available/first variant:", initialVariant.id);
            } else {
                console.error("产品没有任何变体:", product.handle);
                // 如果连第一个变体都没有，后续很多操作会失败，可以提前处理或记录错误
            }
        }
        const moneyFormat = window.Shopify?.currency?.money_format || '${{amount}}';
        const productDescription = product.description || '<p>No description available.</p>';
        const productTitle = product.title || 'Product Title';

        if (variantIdInput) variantIdInput.value = initialVariant.id;
        if (titleElDesktop) titleElDesktop.textContent = productTitle;

        // 价格 (桌面和移动端)
        const initialPriceFormatted = formatMoney(initialVariant.price, moneyFormat);
        const initialComparePriceFormatted = (initialVariant.compare_at_price && initialVariant.compare_at_price > initialVariant.price)
            ? formatMoney(initialVariant.compare_at_price, moneyFormat)
            : '';
        const showInitialComparePrice = initialComparePriceFormatted !== '';

        if (priceElDesktop) priceElDesktop.textContent = initialPriceFormatted;
        if (comparePriceElDesktop) {
            comparePriceElDesktop.textContent = initialComparePriceFormatted;
            comparePriceElDesktop.style.display = showInitialComparePrice ? 'inline' : 'none';
        }
        if (priceContainerDesktop) priceContainerDesktop.style.display = 'block';

        if (priceElMobile) priceElMobile.textContent = initialPriceFormatted;
        if (comparePriceElMobile) {
            comparePriceElMobile.textContent = initialComparePriceFormatted;
            comparePriceElMobile.style.display = showInitialComparePrice ? 'inline' : 'none';
        }
        if (priceContainerMobile) priceContainerMobile.style.display = 'block';

        // 描述
        if (descriptionElDesktop) descriptionElDesktop.innerHTML = productDescription;
        setupDescriptionToggle(descriptionElDesktop, showMoreButtonDesktop);
        if (descriptionElMobile) descriptionElMobile.innerHTML = productDescription;
        setupDescriptionToggle(descriptionElMobile, showMoreButtonMobile);

        // 主图 (桌面)
        let initialDesktopImageMedia = null;
        if (initialVariant.featured_media && initialVariant.featured_media.id) {
            initialDesktopImageMedia = product.media.find(m => m.id === initialVariant.featured_media.id);
        }
        if (!initialDesktopImageMedia && product.media && product.media.length > 0) { // Fallback to product's first image
            initialDesktopImageMedia = product.media.find(m => m.media_type === 'image') || product.media[0];
        }

        if (mainImageDesktop) {
            if (initialDesktopImageMedia && initialDesktopImageMedia.src) {
                mainImageDesktop.src = initialDesktopImageMedia.src;
                mainImageDesktop.alt = initialDesktopImageMedia.alt || product.title;
                mainImageDesktop.style.display = 'block';
            } else {
                mainImageDesktop.style.display = 'none'; // 没有图片则隐藏
            }
        }

        // 桌面缩略图
        if (thumbnailsContainerDesktop) {
            if (!isMobileView && product.media?.filter(m => m.media_type === 'image').length > 1) {
                // setTimeout 仍然可以保留，以确保DOM布局完成后再计算缩略图是否需要滚动等
                setTimeout(() => {
                    populateThumbnails(product.media, thumbnailsContainerDesktop, mainImageDesktop, initialVariant.featured_media?.id);
                }, 50); // 可以尝试缩短延迟
            } else {
                thumbnailsContainerDesktop.style.display = 'none';
            }
        }

        // 按钮状态
        if (buyNowButtonDesktop) buyNowButtonDesktop.disabled = !initialVariant.available; // 基于可用性
        if (bareToolsButtonDesktop) {
            bareToolsButtonDesktop.classList.toggle('custom-modal-hidden', !showBareToolsButton);
            bareToolsButtonDesktop.disabled = !initialVariant.available;
        }
        if (buyNowButtonMobile) buyNowButtonMobile.disabled = !initialVariant.available;
        if (bareToolsButtonMobile) {
            bareToolsButtonMobile.classList.toggle('custom-modal-hidden', !showBareToolsButton);
            bareToolsButtonMobile.disabled = !initialVariant.available;
        }


        // 移动端 Swiper
        const selectedMediaIdForSwiper = initialVariant.featured_media?.id;
        if (isMobileView) {
            populateMobileSwiper(product.media, selectedMediaIdForSwiper); // 直接调用， populateMobileSwiper内部已有 initialSlide
        } else {
            if (mobileSwiperInstance) {
                mobileSwiperInstance.destroy(true, true);
                mobileSwiperInstance = null;
            }
            if (mobileSwiperContainer) mobileSwiperContainer.style.display = 'none';
        }

        // --- 处理变体选项 ---
        const hasVariants = product.variants.length > 1;
        const optionsContainerDesktop = document.getElementById('custom-modal-options-desktop');
        const optionsContainerMobile = document.getElementById('custom-modal-options-mobile');

        if (optionsContainerDesktop) optionsContainerDesktop.innerHTML = '';
        if (optionsContainerMobile) optionsContainerMobile.innerHTML = '';
        if (!hasVariants) {
            if (buyNowButtonDesktop) buyNowButtonDesktop.disabled = false;
            if (buyNowButtonMobile) buyNowButtonMobile.disabled = false;
            if (bareToolsButtonDesktop) bareToolsButtonDesktop.disabled = false;
            if (bareToolsButtonMobile) bareToolsButtonMobile.disabled = false;
            
            // 确保variantIdInput有值
            if (variantIdInput && product.variants[0]) {
                variantIdInput.value = product.variants[0].id;
            }
        } 

        if (hasVariants && product.options && product.options.length > 0) {
            if (optionsContainerDesktop) optionsContainerDesktop.style.display = 'block';
            if (optionsContainerMobile) optionsContainerMobile.style.display = 'flex';

            product.options.forEach((option, index) => {
                // (你的创建选择器包装器的代码不变) ...
                if (optionsContainerDesktop) {
                    const selectorWrapper = document.createElement('div');
                    selectorWrapper.className = 'variant-selector';
                    selectorWrapper.innerHTML = `<div class="variant-options" data-option-index="${index}"></div>`;
                    optionsContainerDesktop.appendChild(selectorWrapper);
                }
                if (optionsContainerMobile) {
                    const selectorWrapper = document.createElement('div');
                    selectorWrapper.className = 'variant-selector';
                    selectorWrapper.innerHTML = `<div class="variant-options" data-option-index="${index}"></div>`;
                    optionsContainerMobile.appendChild(selectorWrapper);
                }
            });

            populateVariantOptions(product); // 这会创建选项并附加事件监听器

            // 确保初始变体的选项被视觉选中，并最终确认价格/图片
            // initialVariant.options[0] 是该变体的第一个选项值，例如 "Black"
            if (initialVariant.options && initialVariant.options[0]) {
                const initialOptionValue = initialVariant.options[0];
                // 短暂延迟以确保选项按钮已渲染完毕可以应用 active 样式
                setTimeout(() => {
                    handleVariantSelection(initialOptionValue, product);
                }, 50); // 这个延迟是为了确保DOM元素已创建
            } else {
                // 如果 initialVariant 没有 options 数组 (例如只有一个变体，没有定义选项名称)
                // 此时不需要 "选择" 任何东西，上面的直接UI更新已经处理了
                console.warn("Initial variant has no options array, UI should be set directly.");
                updatePriceAndAvailability(initialVariant); // 再次确认
                updateVariantImageDisplay(initialVariant, product.media);
            }

        } else { // 没有多变体或没有选项定义
            if (optionsContainerDesktop) optionsContainerDesktop.style.display = 'none';
            if (optionsContainerMobile) optionsContainerMobile.style.display = 'none';
            // 对于单变体产品，价格和图片已由上面的逻辑设置
            // updatePriceAndAvailability(initialVariant); // 再次确认，因为 handleVariantSelection 不会运行
            // updateVariantImageDisplay(initialVariant, product.media);
        }

        // --- 完成加载 ---
        if (skeleton) skeleton.style.display = 'none';
        if (loader) loader.style.display = 'none';
        contentWrapper.style.opacity = '1';
        modal.classList.remove('loading');
        console.log("Modal populated for:", product.title);

    }
    // 填充变体选项
    function populateVariantOptions(product) {
        // 获取第一个选项的所有可能值
        const firstOption = product.options[0];
        const optionValues = firstOption.values;

        // 为每个值创建选项
        optionValues.forEach(value => {
            // 解析颜色和描述
            const parts = value.split(' ');
            const colorName = parts[0];
            const description = parts[0];

            // 获取颜色代码或使用默认
            const colorCode = getColorCode(colorName);

            // 创建桌面端选项
            const desktopOptions = document.querySelectorAll('#custom-modal-options-desktop .variant-options');
            desktopOptions.forEach(container => {
                const option = createVariantOption(colorCode, colorName, description, value);
                container.appendChild(option);
            });

            // 创建移动端选项
            const mobileOptions = document.querySelectorAll('#custom-modal-options-mobile .variant-options');
            mobileOptions.forEach(container => {
                const option = createVariantOption(colorCode, colorName, description, value);
                container.appendChild(option);
            });

        });
    }

    // 创建单个变体选项元素
    function createVariantOption(colorCode, colorName, description, value) {
        const option = document.createElement('div');
        option.className = 'variant-option';
        option.dataset.value = value;

        option.innerHTML = `
        <div class="color-swatch" style="background-color: ${colorCode};"></div>
        <div class="variant-label">${description}</div>
    `;

        option.addEventListener('click', function () {
            const selectedValue = this.dataset.value;
            // 调用新的处理函数，传递选中的值和当前产品数据
            handleVariantSelection(selectedValue, currentProductData);
        });

        return option;
    }

    // 颜色名称到颜色代码的映射
    function getColorCode(colorName) {
        const colorMap = {
            'weiss': '#F5F5F5',
            'black': '#000000',
            'red': '#ff0000',
            'blau': '#ced8de',
            'green': '#008000',
            'gelb': '#e4d7c6',
            'silver': '#c0c0c0',
            'gold': '#ffd700',
            'pink': '#ffc0cb',
            'gray': '#808080',
            // 添加更多颜色映射...
        };

        // 转换为小写比较
        const lowerColor = colorName.toLowerCase();
        return colorMap[lowerColor] || '#cccccc'; // 默认灰色
    }
    function updateVariantSelection(product, selectedVariant) {
        if (!selectedVariant) return;

        // 获取选中的选项值（第一个选项）
        const selectedValue = selectedVariant.options[0];

        // 更新所有选项的选中状态
        document.querySelectorAll('.variant-option').forEach(option => {
            option.classList.remove('active');
            if (option.dataset.value === selectedValue) {
                option.classList.add('active');
            }
        });

        // 更新隐藏的variant_id输入
        if (variantIdInput) {
            variantIdInput.value = selectedVariant.id;
        }

        // 更新价格显示
        updatePriceDisplay(selectedVariant);

        // 更新主图（如果变体有特定图片）
        updateVariantImage(selectedVariant);
    }

    // 设置变体选择器事件
    function setupVariantSelectors(product) {
        document.querySelectorAll('.variant-option').forEach(option => {
            option.addEventListener('click', function () {
                const selectedValue = this.dataset.value;

                // 找到包含这个值的变体
                const selectedVariant = product.variants.find(v =>
                    v.options.includes(selectedValue)
                );

                if (selectedVariant) {
                    updateVariantSelection(product, selectedVariant);
                }
            });
        });
    }


    // 更新价格显示
    function updatePriceDisplay(variant) {
        const moneyFormat = window.Shopify?.currency?.money_format || '${{amount}}';
        const currentPriceFormatted = formatMoney(variant.price, moneyFormat);
        const comparePriceFormatted = (variant.compare_at_price && variant.compare_at_price > variant.price)
            ? formatMoney(variant.compare_at_price, moneyFormat)
            : '';

        // 更新桌面端价格
        if (priceElDesktop) priceElDesktop.textContent = currentPriceFormatted;
        if (comparePriceElDesktop) {
            comparePriceElDesktop.textContent = comparePriceFormatted;
            comparePriceElDesktop.style.display = comparePriceFormatted ? 'inline' : 'none';
        }

        // 更新移动端价格
        if (priceElMobile) priceElMobile.textContent = currentPriceFormatted;
        if (comparePriceElMobile) {
            comparePriceElMobile.textContent = comparePriceFormatted;
            comparePriceElMobile.style.display = comparePriceFormatted ? 'inline' : 'none';
        }

    }

    // 更新变体图片
    function updateVariantImage(variant) {
        if (!variant.featured_media) return;

        // 桌面端主图更新
        if (mainImageDesktop && variant.featured_media.src) {
            mainImageDesktop.src = variant.featured_media.src;
            mainImageDesktop.alt = variant.featured_media.alt || product.title;
        }

        // 移动端Swiper更新（需要找到对应的slide）
        if (mobileSwiperInstance && variant.featured_media) {
            const slideIndex = product.media.findIndex(media =>
                media.id === variant.featured_media.id
            );
            if (slideIndex >= 0) {
                mobileSwiperInstance.slideTo(slideIndex);
            }
        }

        // 更新活动缩略图
        const thumbnails = document.querySelectorAll('.custom-modal-thumbnail');
        thumbnails.forEach(thumb => {
            thumb.classList.remove('active');
            if (thumb.dataset.mediaId === String(variant.featured_media?.id)) {
                thumb.classList.add('active');
            }
        });
    }

    // 5. 填充桌面缩略图 (基本不变, 增加健壮性)
    function populateThumbnails(media, container, mainImageTarget, activeMediaId) {
        if (!container || !mainImageTarget || !media || media.length === 0) {
            if (container) container.style.display = 'none'; // 确保在无效时隐藏容器
            return;
        }
        container.innerHTML = ''; // 清空现有缩略图
        let imageCount = 0;
        let activeThumbFound = false;

        media.forEach((mediaItem) => {
            if (mediaItem.media_type === 'image' && mediaItem.preview_image?.src) { // 确保是图片且有预览图
                imageCount++;
                const thumb = document.createElement('img');
                thumb.loading = 'lazy';
                thumb.src = mediaItem.preview_image.src; // 使用预览图
                thumb.alt = mediaItem.alt || `Thumbnail ${imageCount}`;
                thumb.classList.add('custom-modal-thumbnail');
                thumb.dataset.fullSrc = mediaItem.src; // 完整图片地址
                // thumb.dataset.alt = mediaItem.alt || product.title; // Alt 文本
                thumb.dataset.mediaId = mediaItem.id; // 存储 media ID

                // 标记活动缩略图 (优先匹配 activeMediaId)
                if (mediaItem.id === activeMediaId) {
                    thumb.classList.add('active');
                    activeThumbFound = true;
                }

                thumb.addEventListener('click', () => { // 使用箭头函数简化
                    if (!thumb.classList.contains('active')) {
                        mainImageTarget.src = thumb.dataset.fullSrc;
                        mainImageTarget.alt = thumb.dataset.alt;
                        // 更新活动状态
                        container.querySelectorAll('.custom-modal-thumbnail.active').forEach(t => t.classList.remove('active'));
                        thumb.classList.add('active');
                    }
                });
                container.appendChild(thumb);
            }
        });

        // 如果没有基于 variant 找到激活的缩略图，默认激活第一个
        if (!activeThumbFound && imageCount > 0) {
            const firstThumb = container.querySelector('.custom-modal-thumbnail');
            if (firstThumb) firstThumb.classList.add('active');
        }

        // 只有图片数量大于1时才显示缩略图区域
        container.style.display = imageCount > 1 ? 'flex' : 'none';
    }

    // 6. 处理桌面缩略图点击 (已内联到 populateThumbnails, 此函数不再需要)
    // function handleThumbnailClick(event) { ... }

    // 7. 设置描述展开/收起 (增加健壮性)
    function setupDescriptionToggle(descriptionEl, buttonEl) {
        if (!descriptionEl || !buttonEl) return; // 确保元素存在

        // 重置状态
        descriptionEl.classList.remove('expanded', 'is-collapsible');
        buttonEl.style.display = 'none';
        buttonEl.textContent = 'Mehr anzeigen';
        // 移除旧监听器，防止重复添加
        buttonEl.removeEventListener('click', handleShowMoreClick);

        // 使用 requestAnimationFrame 确保浏览器完成布局计算
        requestAnimationFrame(() => {
            // 检查内容是否溢出 (使用 Math.round 避免浮点数精度问题)
            // 添加一个小的容差 (例如 1px) 可能更可靠
            const tolerance = 1;
            const isOverflowing = descriptionEl.scrollHeight > descriptionEl.clientHeight + tolerance;

            if (isOverflowing) {
                buttonEl.style.display = 'block'; // 显示按钮
                descriptionEl.classList.add('is-collapsible'); // 添加折叠样式类
                // 添加新的点击监听器
                buttonEl.addEventListener('click', handleShowMoreClick);
            } else {
                buttonEl.style.display = 'none'; // 内容未溢出，隐藏按钮
                descriptionEl.classList.remove('is-collapsible'); // 移除折叠样式类
            }
        });
    }

    // 8. 填充移动端 Swiper (增加健壮性)
    function populateMobileSwiper(media, selectedMediaId) {
        if (!mobileSwiperContainer) {
            console.error("找不到移动端 Swiper container 元素");
            return;
        }
        const swiperWrapper = mobileSwiperContainer.querySelector('.swiper-wrapper');

        if (!swiperWrapper) {
            console.error("找不到移动端 Swiper wrapper 元素");
            mobileSwiperContainer.style.display = 'none'; // 隐藏容器
            return;
        }

        swiperWrapper.innerHTML = ''; // 清空现有幻灯片
        let imageCount = 0;
        let initialSlideIndex = 0;

        if (media && media.length > 0) {
            media.forEach((mediaItem, index) => {
                if (mediaItem.media_type === 'image' && mediaItem.src) { // 确保是图片且有 src
                    imageCount++;
                    const slide = document.createElement('div');
                    slide.className = 'swiper-slide';
                    const img = document.createElement('img');
                    img.src = mediaItem.src;
                    img.alt = mediaItem.alt || 'Product Image';
                    img.loading = 'lazy'; // 添加懒加载
                    slide.appendChild(img);
                    swiperWrapper.appendChild(slide);
                    if (selectedMediaId && mediaItem.id === selectedMediaId) {
                        initialSlideIndex = index;
                    }
                }
            });
        }

        // 检查 Swiper 库是否加载
        if (typeof Swiper === 'undefined') {
            console.error("Swiper 库未加载。请确保已在页面中引入 Swiper JS。");
            mobileSwiperContainer.style.display = 'none'; // 隐藏容器
            return;
        }

        // 销毁旧实例 (如果存在)
        if (mobileSwiperInstance) {
            mobileSwiperInstance.destroy(true, true);
            mobileSwiperInstance = null;
            console.log("Previous Mobile Swiper instance destroyed.");
        }

        // 只有在移动视图且有图片时才初始化 Swiper
        if (isMobileView && imageCount > 0) {
            mobileSwiperContainer.style.display = 'block'; // 显示 Swiper 容器
            mobileSwiperInstance = new Swiper(mobileSwiperContainer, { // 使用容器元素初始化
                loop: imageCount > 1, // 只有多于一张图片时才循环
                slidesPerView: 1,
                spaceBetween: 10,
                initialSlide: initialSlideIndex,
                navigation: {
                    nextEl: mobileSwiperContainer.querySelector('.swiper-button-next'), // 限定在容器内查找
                    prevEl: mobileSwiperContainer.querySelector('.swiper-button-prev'), // 限定在容器内查找
                },
                // 可以添加分页器 pagination: { el: '.swiper-pagination', clickable: true },
                // 确保 Swiper 在图片加载后更新布局
                preloadImages: false,
                lazy: {
                    loadPrevNext: true,
                },
                observer: true, // 观察容器变化
                observeParents: true, // 观察父元素变化
                on: {
                    lazyImageReady: () => {
                        this.update();
                    }
                }
            });
            // 手动更新一下以防万一
            setTimeout(() => {
                if (mobileSwiperInstance && !mobileSwiperInstance.destroyed) {
                    mobileSwiperInstance.update();
                }
            }, 100);
            console.log("Mobile Swiper initialized with", imageCount, "images.");
        } else {
            mobileSwiperContainer.style.display = 'none'; // 非移动端或无图片则隐藏
            console.log("Mobile Swiper not initialized (Not mobile view or no images).");
        }
    }

    // 9. 处理 "Show More" 点击 (基本不变)
    function handleShowMoreClick(event) {
        const button = event.currentTarget;
        // 根据按钮 ID 推断对应的描述元素 ID
        const descriptionId = button.id.replace('-show-more-', '-description-');
        const descriptionEl = document.getElementById(descriptionId);

        if (descriptionEl) {
            descriptionEl.classList.toggle('expanded'); // 切换展开/收起状态

            // 更新按钮文本
            if (descriptionEl.classList.contains('expanded')) {
                button.textContent = 'Weniger anzeigen';
            } else {
                button.textContent = 'Mehr anzeigen';
                // 收起时滚动到描述顶部（可选）
                // descriptionEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        } else {
            console.warn("无法找到对应的描述元素:", descriptionId);
        }
    }

    // 10. 处理添加到购物车 (旧的, 保留作为参考或移除)
    // function handleAddToCart(event) { ... } // 已被 handleBuyNow 和 handleBareToolsAddToCartAndClose 替代

    // 11. 打开模态框
    function openModal() {
        // 重置内容区域的滚动位置
        contentWrapper.scrollTop = 0;

        // 显示遮罩和模态框
        overlay.classList.add('active');
        modal.classList.add('active');
        document.body.classList.add('custom-modal-open'); // 防止 body 滚动
        modal.setAttribute('aria-hidden', 'false');
        overlay.setAttribute('aria-hidden', 'false');

        // 焦点管理 - 将焦点设置在关闭按钮上
        if (closeButton) closeButton.focus();

        handleResize(); // 确保初始视图正确 (骨架屏会根据这个判断)
    }

    // 12. 关闭模态框
    function closeModal() {
        overlay.classList.remove('active');
        modal.classList.remove('active');
        modal.classList.remove('loading'); // 确保移除 loading 类
        document.body.classList.remove('custom-modal-open'); // 重新启用 body 滚动
        modal.setAttribute('aria-hidden', 'true');
        overlay.setAttribute('aria-hidden', 'true');

        // 销毁 Swiper 实例
        if (mobileSwiperInstance) {
            mobileSwiperInstance.destroy(true, true);
            mobileSwiperInstance = null;
            console.log("Mobile Swiper destroyed on modal close.");
        }
        // 隐藏骨架屏和内容
        if (skeleton) skeleton.style.display = 'none';
        contentWrapper.style.opacity = '0';

        // 重置数据和按钮状态
        currentProductData = null;
        currentProductType = null;
        resetButtonStates();
        // 清空内容（可选，避免下次打开看到旧内容闪烁）
        // clearModalContent();
    }

    // 13. 重置按钮状态和文本
    function resetButtonStates() {
        const buttons = [
            buyNowButtonDesktop, buyNowButtonMobile,
            bareToolsButtonDesktop, bareToolsButtonMobile
        ];
        const primarySpans = [
            buyNowButtonDesktop?.querySelector('.primary-span'),
            buyNowButtonMobile?.querySelector('.primary-span')
        ];
        const secondarySpans = [
            bareToolsButtonDesktop?.querySelector('.secondary-span'),
            bareToolsButtonMobile?.querySelector('.secondary-span')
        ];

        buttons.forEach(btn => {
            if (btn) {
                btn.disabled = false; // 启用按钮
                btn.classList.remove('custom-modal-hidden'); // 确保按钮可见（除非类型不允许）
            }
        });

        primarySpans.forEach(span => {
            if (span) span.textContent = 'Jetzt kaufen'; // 恢复主要按钮文本
        });
        secondarySpans.forEach(span => {
            if (span) span.textContent = 'Bloße Werkzeuge'; // 恢复次要按钮文本
        });

        const optionsContainerDesktop = document.getElementById('custom-modal-options-desktop');
        const optionsContainerMobile = document.getElementById('custom-modal-options-mobile');
        if (optionsContainerDesktop) optionsContainerDesktop.innerHTML = '';
        if (optionsContainerMobile) optionsContainerMobile.innerHTML = '';
    }
    // (可选) 清空模态框内容函数
    function clearModalContent() {
        if (titleElDesktop) titleElDesktop.textContent = '';
        if (priceElDesktop) priceElDesktop.textContent = '';
        if (comparePriceElDesktop) comparePriceElDesktop.textContent = '';
        if (descriptionElDesktop) descriptionElDesktop.innerHTML = '';
        if (mainImageDesktop) mainImageDesktop.src = '';
        if (thumbnailsContainerDesktop) thumbnailsContainerDesktop.innerHTML = '';

        if (priceElMobile) priceElMobile.textContent = '';
        if (comparePriceElMobile) comparePriceElMobile.textContent = '';
        if (descriptionElMobile) descriptionElMobile.innerHTML = '';
        const swiperWrapper = mobileSwiperContainer?.querySelector('.swiper-wrapper');
        if (swiperWrapper) swiperWrapper.innerHTML = '';

        if (variantIdInput) variantIdInput.value = '';
    }

    // 14. 处理窗口大小调整 (增加健壮性)
    function handleResize() {
        const currentlyMobile = window.innerWidth <= 768;
        if (currentlyMobile !== isMobileView) {
            console.log(`Resize detected: Switching view to ${currentlyMobile ? 'Mobile' : 'Desktop'}`);
            isMobileView = currentlyMobile;


            // 如果模态框是打开的并且有产品数据
            if (modal.classList.contains('active') && currentProductData && !modal.classList.contains('loading')) {
                let currentSelectedVariant = null;
                const selectedVariantId = variantIdInput?.value; // 从隐藏 input 获取 ID

                if (selectedVariantId) {
                    currentSelectedVariant = currentProductData.variants.find(v => v.id == selectedVariantId); // 使用 == 比较
                }

                // 如果没找到选中的，或者 input 为空，则回退
                if (!currentSelectedVariant) {
                    console.log("Resize: Could not find selected variant from input, falling back.");
                    currentSelectedVariant = currentProductData.variants.find(v => v.available) || currentProductData.variants[0];
                } else {
                    console.log("Resize: Using currently selected variant:", currentSelectedVariant.id);
                }
                // --- 切换到移动端 ---
                if (isMobileView) {
                    // 隐藏 PC 缩略图
                    if (thumbnailsContainerDesktop) thumbnailsContainerDesktop.style.display = 'none';
                    // 初始化 Swiper (populateMobileSwiper 会处理销毁旧实例)
                    const selectedVariantId = variantIdInput?.value;
                    populateMobileSwiper(currentProductData.media, selectedVariantId);
                    // 确保移动端描述状态正确
                    setupDescriptionToggle(descriptionElMobile, showMoreButtonMobile);
                }
                // --- 切换到桌面端 ---
                else {
                    // 销毁 Swiper
                    if (mobileSwiperInstance) {
                        mobileSwiperInstance.destroy(true, true);
                        mobileSwiperInstance = null;
                        console.log("Mobile Swiper destroyed on resize to desktop.");
                    }
                    if (mobileSwiperContainer) mobileSwiperContainer.style.display = 'none'; // 隐藏 swiper 容器

                    // 重新填充并显示 PC 缩略图
                    // const firstVariant = currentProductData.variants.find(v => v.available) || currentProductData.variants[0];
                    if (thumbnailsContainerDesktop && mainImageDesktop) {
                        populateThumbnails(
                            currentProductData.media,
                            thumbnailsContainerDesktop,
                            mainImageDesktop,
                            currentSelectedVariant?.featured_media?.id // 使用当前选中变体的媒体ID
                        );
                        // *** 确保主图也更新为当前选中变体的图片 ***
                        if (currentSelectedVariant?.featured_media?.src) {
                            mainImageDesktop.src = currentSelectedVariant.featured_media.src;
                            mainImageDesktop.alt = currentSelectedVariant.featured_media.alt || currentProductData.title;
                        } else if (currentProductData.media && currentProductData.media.length > 0) {
                            // Fallback to first image if selected variant has no featured media
                            const firstImage = currentProductData.media.find(m => m.media_type === 'image') || currentProductData.media[0];
                            if (firstImage) {
                                mainImageDesktop.src = firstImage.src;
                                mainImageDesktop.alt = firstImage.alt || currentProductData.title;
                            }
                        }
                        // populateThumbnails(currentProductData.media, thumbnailsContainerDesktop, mainImageDesktop, firstVariant?.featured_media?.id);
                    }
                    // 确保桌面端描述状态正确
                    setupDescriptionToggle(descriptionElDesktop, showMoreButtonDesktop);
                }
            } else if (modal.classList.contains('loading')) {
                // 如果在加载时调整大小，只需确保骨架屏的媒体查询生效即可
                console.log("Resized while loading, skeleton CSS should handle the view.");
            }
        }
    }

    // 15. 全局函数，用于从外部打开模态框
    window.openProductModal = function (productHandle, selectedVariantId = null, productType = null) {
        console.log("Opening modal for handle:", productHandle, "Selected Variant ID:", selectedVariantId, "Type:", productType);
        if (!productHandle) {
            console.error('打开模态框需要产品 handle。');
            return;
        }

        // --- 重置并显示加载状态 ---
        resetButtonStates(); // 重置按钮以防上次残留
        // clearModalContent(); // (可选) 清空旧内容
        contentWrapper.style.opacity = '0'; // 隐藏实际内容区域
        if (loader) loader.style.display = 'none'; // 隐藏旧加载器
        if (skeleton) skeleton.style.display = 'block'; // **显示骨架屏**
        modal.classList.add('loading'); // 添加 loading 类以触发骨架屏 CSS
        openModal(); // 打开模态框结构

        // 获取产品数据
        fetch(`/products/${productHandle}.js`)
            .then(response => {
                if (!response.ok) {
                    // 尝试解析错误信息
                    return response.json().then(errData => {
                        throw new Error(errData.description || `HTTP 错误！状态: ${response.status}`);
                    }).catch(() => {
                        // 如果解析json也失败，抛出通用错误
                        throw new Error(`HTTP 错误！状态: ${response.status}`);
                    });
                }
                return response.json();
            })
            .then(product => {
                // 确保模态框仍然是打开状态再填充
                if (modal.classList.contains('active')) {
                    populateModal(product, productType, selectedVariantId);
                } else {
                    console.log("Modal closed before product data arrived for:", productHandle);
                }
            })
            .catch(error => {
                console.error('获取产品数据时出错:', error);
                // 确保模态框仍然打开再显示错误
                if (modal.classList.contains('active')) {
                    if (skeleton) skeleton.style.display = 'none'; // 隐藏骨架屏
                    contentWrapper.innerHTML = `<p style="color: red; text-align: center; padding: 40px;">无法加载产品详情: ${error.message}. 请稍后重试。</p>`; // 显示错误信息
                    contentWrapper.style.opacity = '1'; // 显示错误信息容器
                    modal.classList.remove('loading'); // 移除 loading 状态
                }
            });
    }

    // --- 事件监听器 ---
    if (closeButton) closeButton.addEventListener('click', closeModal);
    if (overlay) overlay.addEventListener('click', (e) => {
        // 防止点击模态框内部关闭
        if (e.target === overlay) {
            closeModal();
        }
    });

    // "Bare Tools" 按钮 (加购并关闭)
    if (bareToolsButtonDesktop) bareToolsButtonDesktop.addEventListener('click', handleBareToolsAddToCartAndClose);
    if (bareToolsButtonMobile) bareToolsButtonMobile.addEventListener('click', handleBareToolsAddToCartAndClose);

    // "Buy Now" 按钮 (直接结账)
    if (buyNowButtonDesktop) buyNowButtonDesktop.addEventListener('click', handleBuyNow);
    if (buyNowButtonMobile) buyNowButtonMobile.addEventListener('click', handleBuyNow);

    // ESC 键关闭模态框
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.classList.contains('active')) {
            closeModal();
        }
    });

    // 窗口大小调整监听
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(handleResize, 250); // Debounce resize event
    });

    // 初始检查视图
    handleResize();

});